export default __webpack_public_path__ + "static/media/back_profile2.0116dda8.jpg";